import * as tslib_1 from "tslib";
import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';
const ɵ0 = () => UserNameDisplayResultDto, ɵ1 = () => Date, ɵ2 = () => UserNameDisplayResultDto, ɵ3 = () => Date, ɵ4 = () => Date, ɵ5 = () => UserNameDisplayResultDto, ɵ6 = () => Date, ɵ7 = () => UserNameDisplayResultDto;
export class ProjectTaskItemResultDto {
    get enteredByDisplayText() {
        return Utils.notNullAndDefined(this.enteredBy) ? this.enteredBy.displayName : '';
    }
    get responsibleDisplayText() {
        return Utils.notNullAndDefined(this.responsible) ? this.responsible.displayName : '';
    }
    get statusChangedByDisplayText() {
        return Utils.notNullAndDefined(this.statusChangedBy) ? this.statusChangedBy.displayName : '';
    }
    get dashboardResponsibleDisplayText() {
        return Utils.notNullAndDefined(this.dashboardResponsible) ? this.dashboardResponsible.displayName : '';
    }
    get dashboardStatusDisplayText() {
        let displayText = null;
        if (Utils.isTrue(this.problematic)) {
            displayText = 'Problematic';
        }
        else if (Utils.isTrue(this.priority)) {
            displayText = 'Priority';
        }
        return displayText;
    }
    get workOrderIdsDisplayText() {
        return Utils.notNullOrEmpty(this.workOrderIds) ? this.workOrderIds.join(',') : null;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], ProjectTaskItemResultDto.prototype, "enteredBy", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Date)
], ProjectTaskItemResultDto.prototype, "enteredOn", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], ProjectTaskItemResultDto.prototype, "responsible", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Date)
], ProjectTaskItemResultDto.prototype, "dueDate", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", Date)
], ProjectTaskItemResultDto.prototype, "statusChangedOn", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], ProjectTaskItemResultDto.prototype, "statusChangedBy", void 0);
tslib_1.__decorate([
    Type(ɵ6),
    tslib_1.__metadata("design:type", Date)
], ProjectTaskItemResultDto.prototype, "lastModified", void 0);
tslib_1.__decorate([
    Type(ɵ7),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], ProjectTaskItemResultDto.prototype, "dashboardResponsible", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7 };
